const FormConfig = require('./formConfig');
const useUserInputsRendererState = require('./useUserInputsRendererState');
const useUserInputsSignupDetails = require('./useUserInputsSignupDetails');
const useUserInputsSubmitController = require('./useUserInputsSubmitController');
const useUserInputsValidation = require('./useUserInputsValidation');

module.exports = function useUserInputsRendererController(props) {

    const {
        children,
        formConfig = FormConfig,
        formMethods,
        inputRefs = {},
        onInvalidSubmit,
        preferencesHandle,
        renderFields,
        shouldScrollToInterests
    } = props;

    const {
        rendererStateRef,
        setRendererState,
        getFieldValue,
        getRendererStateSlice,
        getRendererUiState
    } = useUserInputsRendererState({
        formConfig,
        formMethods,
        inputRefs,
        props,
        shouldScrollToInterests
    });

    const {
        validate
    } = useUserInputsValidation({
        formConfig,
        getFieldValue,
        inputRefs,
        rendererStateRef,
        props
    });

    const {
        fields,
        validationFields,
        getSignupDetails
    } = useUserInputsSignupDetails({
        formConfig,
        getFieldValue,
        preferencesHandle
    });

    const {
        submit
    } = useUserInputsSubmitController({
        fields: validationFields,
        formMethods,
        getFieldValue,
        getRendererStateSlice,
        getSignupDetails,
        inputRefs,
        onInvalidSubmit,
        preferencesHandle,
        props,
        setRendererState,
        validate
    });

    return {
        children,
        formMethods,
        getSignupDetails,
        renderFields,
        submit,
        uiState: getRendererUiState()
    };
};
